"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StopPropagation = exports.IconHoverComponent = exports.IconComponent = exports.HandleOpen = exports.HandleClose = void 0;
var HelpTextMethods = _interopRequireWildcard(require("./HelpText"));
var ScrollMethods = _interopRequireWildcard(require("./../../utils/scroll"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _common = require("./../../config/common");
var _ImportedContentFragment = _interopRequireDefault(require("./../ContentFragments/ImportedContentFragment"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _InfoOutlined = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("./../../utils/type-checks/function");
var _object = require("./../../utils/type-checks/object");
var _string = require("./../../utils/type-checks/string");
var _theme = _interopRequireDefault(require("./../../scss/theme.scss"));
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  IconComponent = props => /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, _extends({
    "data-icon-id": "HelpText__default-icon"
  }, props)),
  IconHoverComponent = props => /*#__PURE__*/_react.default.createElement(_Info.default, _extends({
    "data-icon-id": "HelpText__default-hover-icon"
  }, props)),
  HandleClose = (open, buttonRef, setOpen) => {
    let result = false;
    if (open === true && (0, _function.isFunction)(setOpen)) {
      if ((0, _object.isObject)(buttonRef) && (0, _object.isObject)(buttonRef.current)) {
        ScrollMethods.moveFocus(buttonRef.current);
      }
      setOpen(!open);
      result = true;
    }
    return result;
  },
  HandleOpen = (e, open, setOpen) => {
    let result = false;
    if (open === false && (0, _function.isFunction)(setOpen)) {
      window.PubSub.publish("click.tooltip");
      HelpTextMethods.StopPropagation(e);
      setTimeout(() => {
        setOpen(!open);
      }, 5);
      result = true;
    }
    return result;
  },
  StopPropagation = e => {
    let result = false;
    if ((0, _object.isObject)(e) && (0, _object.isObject)(e.target) && !e.target.hasAttribute(_common.HTML_DATA_ATTR_INJECTED) && (0, _function.isFunction)(e.stopPropagation)) {
      e.stopPropagation();
      result = true;
    }
    return result;
  };

/**
 * Pop-up Help Text
 *
 * @visibleName Help Text
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.StopPropagation = StopPropagation;
exports.HandleOpen = HandleOpen;
exports.HandleClose = HandleClose;
exports.IconHoverComponent = IconHoverComponent;
exports.IconComponent = IconComponent;
const HelpText = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      children,
      className,
      customTheme = {},
      fragmentId,
      IconDefault = props => /*#__PURE__*/_react.default.createElement(IconComponent, props),
      IconHover = props => /*#__PURE__*/_react.default.createElement(IconHoverComponent, props),
      isOpen = false,
      label,
      popperClassName,
      popperStyles = {},
      styles = {},
      testId,
      title,
      ...rest
    } = props,
    [open, setOpen] = (0, _react.useState)(isOpen),
    buttonRef = (0, _react.useRef)(null),
    compositeTheme = merge({
      fontFamilies: {
        default: _theme.default.fontPrimary
      }
    }, customTheme),
    componentStyles = merge({
      alignItems: "baseline",
      borderRadius: "0",
      color: "inherit",
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      justifyContent: "flex-start",
      margin: "0",
      padding: "0",
      textAlign: "left",
      "&:hover,&:active,&:focus-visible": {
        textDecoration: "underline",
        ".HelpText__icon-button": {
          display: "none"
        },
        ".HelpText__icon-button--isHover": {
          display: "block"
        }
      },
      ".HelpText__icon-button,.HelpText__icon-button--isHover": {
        display: isOpen === true ? "none" : "block",
        height: "1.9rem",
        margin: "0 0 0 0.2rem",
        padding: "0",
        width: "1.9rem"
      },
      ".HelpText__icon-button--isHover": {
        display: isOpen === true ? "block" : "none"
      },
      ".HelpText__icon-label": {
        display: "inline-block",
        position: "relative",
        top: "-0.3rem"
      }
    }, styles),
    compiledClassnames = (0, _classnames.default)({
      "HelpText": true,
      [`${className}`]: className
    }),
    compiledPopperClassnames = (0, _classnames.default)({
      "HelpText__content": true,
      [`${popperClassName}`]: popperClassName
    }),
    focusText = (0, _react.useCallback)(node => {
      if (node !== null) {
        ScrollMethods.moveFocus(node);
      }
    }, []),
    tooltipStyles = merge({
      zIndex: "980",
      ".MuiTooltip-tooltip": {
        background: "white",
        border: "0.2rem solid transparent",
        borderRadius: "0.8rem",
        boxShadow: "0 0 1.5rem 0 rgba(0, 0, 0, 0.25)",
        display: "block",
        fontFamily: compositeTheme.fontFamilies.default,
        color: "inherit",
        fontSize: "1.4rem",
        marginBottom: "1.8rem",
        outline: "none",
        padding: "0.5rem 2rem 2rem",
        width: "36rem",
        zIndex: "1"
      },
      ".MuiTooltip-arrow": {
        color: "white",
        fontSize: "2.5rem"
      },
      ".HelpText__content-container": {
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column-reverse"
      },
      ".HelpText__content-button": {
        alignSelf: "flex-end",
        borderRadius: "0",
        color: "black",
        fontFamily: compositeTheme.fontFamilies.default,
        fontSize: "1.2rem",
        marginRight: "-0.5rem",
        paddingRight: "0",
        textAlign: "right",
        "&:hover,&:active,&:focus-visible": {
          textDecoration: "underine"
        }
      },
      ".HelpText__content-button-icon": {
        height: "1.9rem",
        marginLeft: "0.2rem",
        width: "1.9rem"
      }
    }, popperStyles),
    handleClose = (0, _react.useCallback)(() => HelpTextMethods.HandleClose(open, buttonRef, setOpen), [open]),
    handleOpen = e => HelpTextMethods.HandleOpen(e, open, setOpen);
  (0, _react.useEffect)(() => {
    let binding = false;
    if (open === true) {
      binding = true;
      window.PubSub.subscribe("click.tooltip", handleClose);
      document.addEventListener("click", handleClose);
    }
    return () => {
      if (binding === true) {
        document.removeEventListener("click", handleClose);
        window.PubSub.unsubscribe("click.tooltip");
      }
      ;
    };
  }, [handleClose, open]);
  return /*#__PURE__*/_react.default.createElement(_material.Tooltip, _extends({
    arrow: true,
    className: compiledClassnames,
    classes: {
      popper: compiledPopperClassnames
    },
    component: "span",
    "data-testid": testId,
    disableFocusListener: true,
    disableHoverListener: true,
    disableTouchListener: true,
    open: open,
    PopperProps: {
      sx: tooltipStyles
    },
    sx: componentStyles,
    title: /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "HelpText__content-container",
      component: "div",
      onClick: e => HelpTextMethods.StopPropagation(e)
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "HelpText__content-message",
      component: "div",
      ref: focusText,
      tabIndex: "-1"
    }, title && /*#__PURE__*/_react.default.createElement(_material.Box, {
      component: "p"
    }, title), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      id: fragmentId
    })), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      "aria-label": "Close Help Text",
      className: "HelpText__content-button",
      disableFocusRipple: true,
      disableRipple: true,
      onClick: handleClose
    }, "Close ", /*#__PURE__*/_react.default.createElement(_Close.default, {
      className: "HelpText__content-button-icon",
      color: "primary"
    })))
  }, rest), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": !(0, _string.isStringOfLength)(label) && !children ? "More Information" : undefined,
    className: "HelpText__button",
    disableFocusRipple: true,
    disableRipple: true,
    onClick: handleOpen,
    ref: buttonRef
  }, (label || children) && /*#__PURE__*/_react.default.createElement("span", {
    className: "HelpText__icon-label"
  }, label, label && children && " ", children), /*#__PURE__*/_react.default.createElement(IconDefault, {
    className: "HelpText__icon-button",
    color: "primary"
  }), /*#__PURE__*/_react.default.createElement(IconHover, {
    className: "HelpText__icon-button--isHover",
    color: "primary"
  })));
};

// Define propTypes;
HelpText.propTypes = {
  /** Interor content for help button */
  children: _propTypes.default.any,
  /** Custom class(es) object for inline tooltip */
  className: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Fragment ID of popper fragment content */
  fragmentId: _propTypes.default.string,
  /** Default button icon (Default Value: props => <IconComponent {...props} />) */
  IconDefault: _propTypes.default.any,
  /** Hover button icon (Default Value: props => <IconHoverComponent {...props} />) */
  IconHover: _propTypes.default.any,
  /** Boolean to force help message popper window open */
  isOpen: _propTypes.default.bool,
  /** Label text for help button */
  label: _propTypes.default.string,
  /** Custom class(es) object for poppper window */
  popperClassName: _propTypes.default.string,
  /** Custom style object for poppper window (Default Value: {}) */
  popperStyles: _propTypes.default.object,
  /** Custom style object for component (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Title text of help message popper label */
  title: _propTypes.default.any
};

// Export component as default;
var _default = exports.default = HelpText;